import { render, staticRenderFns } from "./DocumentBlockList.vue?vue&type=template&id=70a21b38&scoped=true"
import script from "./DocumentBlockList.vue?vue&type=script&lang=js"
export * from "./DocumentBlockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a21b38",
  null
  
)

export default component.exports